function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M2 5.5C2 4.67969 2.67969 4 3.5 4H12.5C13.3203 4 14 4.67969 14 5.5V11.5C14 12.3203 13.3203 13 12.5 13H3.5C2.67969 13 2 12.3203 2 11.5V5.5ZM6.125 8.125C6.125 7.82031 5.86719 7.5625 5.5625 7.5625H3.6875C3.38281 7.5625 3.125 7.82031 3.125 8.125C3.125 8.42969 3.38281 8.6875 3.6875 8.6875H5.5625C5.86719 8.6875 6.125 8.42969 6.125 8.125ZM6.125 10.1875C6.125 9.88281 5.86719 9.625 5.5625 9.625H3.6875C3.38281 9.625 3.125 9.88281 3.125 10.1875C3.125 10.4922 3.38281 10.75 3.6875 10.75H5.5625C5.86719 10.75 6.125 10.4922 6.125 10.1875ZM7.25 11.875H12.5C12.7109 11.875 12.875 11.7109 12.875 11.5V5.5C12.875 5.28906 12.7109 5.125 12.5 5.125H7.25V11.875ZM6.125 6.0625C6.125 5.75781 5.86719 5.5 5.5625 5.5H3.6875C3.38281 5.5 3.125 5.75781 3.125 6.0625C3.125 6.36719 3.38281 6.625 3.6875 6.625H5.5625C5.86719 6.625 6.125 6.36719 6.125 6.0625Z",
  fill: "currentColor"
});

function SvgCollapseIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollapseIcon);
export default __webpack_public_path__ + "static/media/collapse-icon.a8ca7a45.svg";
export { ForwardRef as ReactComponent };